import * as api from '../api/webpage';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const WEBPAGE_SEARCH_OPTIONS_FETCH_START =
  'APPRAISAL/WEBPAGE_SEARCH_OPTIONS_FETCH_START';
export const WEBPAGE_SEARCH_OPTIONS_FETCH_SUCCESS =
  'APPRAISAL/WEBPAGE_SEARCH_OPTIONS_FETCH_SUCCESS';
export const WEBPAGE_SEARCH_OPTIONS_FETCH_ERROR =
  'APPRAISAL/WEBPAGE_SEARCH_OPTIONS_FETCH_ERROR';

export const WEBPAGE_SEARCH_START = 'APPRAISAL/WEBPAGE_SEARCH_START';
export const WEBPAGE_SEARCH_SUCCESS = 'APPRAISAL/WEBPAGE_SEARCH_SUCCESS';
export const WEBPAGE_SEARCH_ERROR = 'APPRAISAL/WEBPAGE_SEARCH_ERROR';

export const WEBPAGE_TAGS_FETCH_START = 'APPRAISAL/WEBPAGE_TAGS_FETCH_START';
export const WEBPAGE_TAGS_FETCH_SUCCESS =
  'APPRAISAL/WEBPAGE_TAGS_FETCH_SUCCESS';
export const WEBPAGE_TAGS_FETCH_ERROR = 'APPRAISAL/WEBPAGE_TAGS_FETCH_ERROR';

export const WEBPAGE_FIELDS_FETCH_START =
  'APPRAISAL/WEBPAGE_FIELDS_FETCH_START';
export const WEBPAGE_FIELDS_FETCH_SUCCESS =
  'APPRAISAL/WEBPAGE_FIELDS_FETCH_SUCCESS';
export const WEBPAGE_FIELDS_FETCH_ERROR =
  'APPRAISAL/WEBPAGE_FIELDS_FETCH_ERROR';

export const WEBPAGE_CHANGE_CURRENT_PAGE =
  'APPRAISAL/WEBPAGE_CHANGE_CURRENT_PAGE';
export const WEBPAGE_CHANGE_SORT_MODEL = 'APPRAISAL/WEBPAGE_CHANGE_SORT_MODEL';
export const WEBPAGE_CHANGE_PAGE_SIZE = 'APPRAISAL/WEBPAGE_CHANGE_PAGE_SIZE';

export const WEBPAGE_RESET_DATA = 'APPRAISAL/WEBPAGE_RESET_DATA';
export const WEBPAGE_FETCH_START = 'APPRAISAL/WEBPAGE_FETCH_START';
export const WEBPAGE_FETCH_SUCCESS = 'APPRAISAL/WEBPAGE_FETCH_SUCCESS';
export const WEBPAGE_FETCH_ERROR = 'APPRAISAL/WEBPAGE_FETCH_ERROR';

export const WEBPAGE_UPDATE_START = 'APPRAISAL/WEBPAGE_UPDATE_START';
export const WEBPAGE_UPDATE_SUCCESS = 'APPRAISAL/WEBPAGE_UPDATE_SUCCESS';
export const WEBPAGE_UPDATE_ERROR = 'APPRAISAL/WEBPAGE_UPDATE_ERROR';

export const WEBPAGE_NOTES_FETCH_START = 'APPRAISAL/WEBPAGE_NOTES_FETCH_START';
export const WEBPAGE_NOTES_FETCH_SUCCESS =
  'APPRAISAL/WEBPAGE_NOTES_FETCH_SUCCESS';
export const WEBPAGE_NOTES_FETCH_ERROR = 'APPRAISAL/WEBPAGE_NOTES_FETCH_ERROR';

export const WEBPAGE_NOTE_ADD_START = 'APPRAISAL/WEBPAGE_NOTE_ADD_START';
export const WEBPAGE_NOTE_ADD_SUCCESS = 'APPRAISAL/WEBPAGE_NOTE_ADD_SUCCESS';
export const WEBPAGE_NOTE_ADD_ERROR = 'APPRAISAL/WEBPAGE_NOTE_ADD_ERROR';

export const WEBPAGE_NOTE_UPDATE_START = 'APPRAISAL/WEBPAGE_NOTE_UPDATE_START';
export const WEBPAGE_NOTE_UPDATE_SUCCESS =
  'APPRAISAL/WEBPAGE_NOTE_UPDATE_SUCCESS';
export const WEBPAGE_NOTE_UPDATE_ERROR = 'APPRAISAL/WEBPAGE_NOTE_UPDATE_ERROR';

export const WEBPAGE_NOTE_DELETE_START = 'APPRAISAL/WEBPAGE_NOTE_DELETE_START';
export const WEBPAGE_NOTE_DELETE_SUCCESS =
  'APPRAISAL/WEBPAGE_NOTE_DELETE_SUCCESS';
export const WEBPAGE_NOTE_DELETE_ERROR = 'APPRAISAL/WEBPAGE_NOTE_DELETE_ERROR';

export const WEBPAGE_VALIDATE_START = 'APPRAISAL/WEBPAGE_VALIDATE_START';
export const WEBPAGE_VALIDATE_SUCCESS = 'APPRAISAL/WEBPAGE_VALIDATE_SUCCESS';
export const WEBPAGE_VALIDATE_ERROR = 'APPRAISAL/WEBPAGE_VALIDATE_ERROR';

export const WEBPAGE_CREATE = createRequestTypes('APPRAISAL/WEBPAGE_CREATE');
export const WEBPAGE_LIST_FETCH = createRequestTypes(
  'APPRAISAL/WEBPAGE_LIST_FETCH',
);
export const WEBPAGE_DELETE = createRequestTypes('APPRAISAL/WEBPAGE_DELETE');
export const WEBPAGE_DUPLICATE = createRequestTypes(
  'APPRAISAL/WEBPAGE_DUPLICATE',
);

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  WEBPAGE_SEARCH_OPTIONS_FETCH_START,
  WEBPAGE_SEARCH_OPTIONS_FETCH_SUCCESS,
  WEBPAGE_SEARCH_OPTIONS_FETCH_ERROR,
);
export const fetchWebpages = makeApiActionCreatorV3(
  api.fetchWebpages,
  WEBPAGE_LIST_FETCH[START],
  WEBPAGE_LIST_FETCH[SUCCESS],
  WEBPAGE_LIST_FETCH[ERROR],
);
// export const searchWebpage = makeApiActionCreatorV3(api.searchWebpage, WEBPAGE_SEARCH_START, WEBPAGE_SEARCH_SUCCESS, WEBPAGE_SEARCH_ERROR);
// export const fetchFields = makeApiActionCreatorV3(api.fetchFields, WEBPAGE_FIELDS_FETCH_START, WEBPAGE_FIELDS_FETCH_SUCCESS, WEBPAGE_FIELDS_FETCH_ERROR);
// export const fetchTags = makeApiActionCreatorV3(api.fetchTags, WEBPAGE_TAGS_FETCH_START, WEBPAGE_TAGS_FETCH_SUCCESS, WEBPAGE_TAGS_FETCH_ERROR);
export const fetchWebpage = makeApiActionCreatorV3(
  api.fetchWebpage,
  WEBPAGE_FETCH_START,
  WEBPAGE_FETCH_SUCCESS,
  WEBPAGE_FETCH_ERROR,
);
export const updateWebpage = makeApiActionCreatorV3(
  api.updateWebpage,
  WEBPAGE_UPDATE_START,
  WEBPAGE_UPDATE_SUCCESS,
  WEBPAGE_UPDATE_ERROR,
);
export const createWebpage = makeApiActionCreatorV3(
  api.createWebpage,
  WEBPAGE_CREATE[START],
  WEBPAGE_CREATE[SUCCESS],
  WEBPAGE_CREATE[ERROR],
);
export const deleteWebpage = makeApiActionCreatorV3(
  api.deleteWebpage,
  WEBPAGE_DELETE[START],
  WEBPAGE_DELETE[SUCCESS],
  WEBPAGE_DELETE[ERROR],
);
export const fetchWebpageNotes = makeApiActionCreatorV3(
  api.fetchWebpageNotes,
  WEBPAGE_NOTES_FETCH_START,
  WEBPAGE_NOTES_FETCH_SUCCESS,
  WEBPAGE_NOTES_FETCH_ERROR,
);
export const updateWebpageNote = makeApiActionCreatorV3(
  api.updateWebpageNote,
  WEBPAGE_NOTE_UPDATE_START,
  WEBPAGE_NOTE_UPDATE_SUCCESS,
  WEBPAGE_NOTE_UPDATE_ERROR,
);
export const addWebpageNote = makeApiActionCreatorV3(
  api.addWebpageNote,
  WEBPAGE_NOTE_ADD_START,
  WEBPAGE_NOTE_ADD_SUCCESS,
  WEBPAGE_NOTE_ADD_ERROR,
);
export const deleteWebpageNote = makeApiActionCreatorV3(
  api.deleteWebpageNote,
  WEBPAGE_NOTE_DELETE_START,
  WEBPAGE_NOTE_DELETE_SUCCESS,
  WEBPAGE_NOTE_DELETE_ERROR,
);
export const validateWebpage = makeApiActionCreatorV3(
  api.validateWebpage,
  WEBPAGE_VALIDATE_START,
  WEBPAGE_VALIDATE_SUCCESS,
  WEBPAGE_VALIDATE_ERROR,
);
export const duplicateWebpage = makeApiActionCreatorV3(
  api.duplicateWebpage,
  WEBPAGE_DUPLICATE[START],
  WEBPAGE_DUPLICATE[SUCCESS],
  WEBPAGE_DUPLICATE[ERROR],
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: WEBPAGE_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: WEBPAGE_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: WEBPAGE_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetWebpageData() {
  return async dispatch => {
    dispatch({ type: WEBPAGE_RESET_DATA });
  };
}
